import React, { ReactNode } from 'react';

type SignUpFormItem = {
  type: 'text' | 'email' | 'password' | 'custom';
  label: string;
  name: string;
  rules?: Array<{ required: boolean }>;
  render?: () => ReactNode;
};

const globalCompanies: SignUpFormItem[] = [
  {
    type: 'text',
    label: 'Schema ID',
    name: 'schema_id',
    rules: [
      {
        required: true
      }
    ]
  },
  {
    type: 'text',
    label: 'Company Name',
    name: 'company_name',
    rules: [
      {
        required: true
      }
    ]
  },
  {
    type: 'text',
    label: 'Access Status',
    name: 'access_status',
    rules: [
      {
        required: true
      }
    ]
  },
  {
    type: 'text',
    label: 'Billing Status',
    name: 'billing_status',
    rules: [
      {
        required: true
      }
    ]
  },
  {
    type: 'text',
    label: 'Emergency Status',
    name: 'emergency_status',
    rules: [
      {
        required: true
      }
    ]
  },
  {
    type: 'text',
    label: 'Description',
    name: 'description'
  }
];

export default globalCompanies;
